export default "__VITE_ASSET__6b310956__"